// Purpose: typed wrapper around GET /api/admin/dashboard.

import { api } from './client.ts';

export interface RoutingCircuitBreakerFamily {
  state: 'closed' | 'open' | 'half-open';
  failureCount: number;
  lastOpenedAt: string | null;
}

export interface RoutingCircuitBreakerSnapshot {
  list: RoutingCircuitBreakerFamily;
  upload: RoutingCircuitBreakerFamily;
  mail: RoutingCircuitBreakerFamily;
}

export interface RoutingSnapshot {
  pending: number;
  active: number;
  completed24h: number;
  dead: number;
  oldestDeadAgeSeconds: number | null;
  circuitBreakers: RoutingCircuitBreakerSnapshot;
  cert: { thumbprint: string; expiresAt: string; daysRemaining: number } | null;
}

export interface DashboardResponse {
  timestamp: string;
  tiles: {
    activeDropboxes: number;
    activeShares: number;
    pendingApprovals: number;
    sharesExpiringSoon: number;
    routing24hByStatus: Record<string, number>;
    routingSnapshot: RoutingSnapshot | null;
    auditRowCount: number;
  };
}

export async function fetchDashboard(): Promise<DashboardResponse> {
  const res = await api.get<DashboardResponse>('/admin/dashboard');
  return res.data;
}
